module.exports = __webpack_public_path__ + "static/media/pattern_min_JPG.1fb37d36.jpg";